import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { handleError } from '../../../components/errors/errorHandling';
import { DataFormModel } from '../../../components/form/public/utilities/FormModels';
import { getSubmission } from '../../../services/form/FormService';
import { RootState } from '../../../store';

const useSubmission = (submissionId?: string, formId?: string) => {
  const [currentSubmissionId, setCurrentSubmissionId] = useState(submissionId);
  const [currentFormId, setCurrentFormId] = useState(formId);
  const [currentForm, setCurrentForm] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentSubmission, setCurrentSubmission] = useState<DataFormModel>();
  const organizationId = useSelector((state: RootState) => state.organization.organization?.id);

  useEffect(() => {
    if (!currentSubmissionId || !currentFormId || !organizationId) {
      // TODO Set invalid properties
      return;
    }
    setIsLoading(true);
    loadAsync();
  }, [currentSubmissionId, currentFormId, organizationId]);

  const loadAsync = async () => {
    try {
      if (organizationId && currentFormId && currentSubmissionId) {
        const submission = await getSubmission(organizationId, currentFormId, currentSubmissionId);
        setCurrentSubmission(submission.data.submission);
        setCurrentForm(submission.data.form);
      }
    } catch (error) {
      handleError(error);
    }
    setIsLoading(false);
  };

  return {
    currentSubmission,
    setCurrentSubmissionId,
    setCurrentFormId,
    isLoading,
    currentForm,
    setCurrentSubmission,
    reloadSubmission: loadAsync,
  };
};

export default useSubmission;
